import { GeneralError } from "@/features/errors/general-error";

export const Route = createFileRoute({
  component: GeneralError,
});
